import { c as _c } from "react/compiler-runtime";
import { useStripe } from '@stripe/react-stripe-js';
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { getStripeCustomerConfirmIntentMethod } from 'modules/profile/user-plan/utils/user-plan-stripe-utils';
export const useStripeUserPlanConfirmation = paymentMethod => {
  const $ = _c(3);
  const stripeObject = useStripe();
  let t0;
  if ($[0] !== paymentMethod || $[1] !== stripeObject) {
    const confirmIntent = async intentClientSecret => {
      const secureHandler = getStripeCustomerConfirmIntentMethod(stripeObject, paymentMethod);
      if (!secureHandler) {
        return {};
      }
      const result = await secureHandler(intentClientSecret);
      return result.error ? {
        error: "Payment intent confirmation failed: " + result.error.message
      } : {};
    };
    t0 = {
      confirmIntent
    };
    $[0] = paymentMethod;
    $[1] = stripeObject;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};